module.exports = __webpack_public_path__ + "static/img/ground7.532c6ab5.png";